import defaultChecked from '@ecp/common/src/assets/theme/skypass/icon/checkbox--checked.svg';
import defaultDisabled from '@ecp/common/src/assets/theme/skypass/icon/checkbox--disabled.svg';
import defaultUnchecked from '@ecp/common/src/assets/theme/skypass/icon/checkbox--unchecked.svg';
import attendanceChecked from '@ecp/common/src/assets/theme/skypass/icon/attendance--checked.svg';

export const favicon = '/skypass_favicon.ico';

export const color = {
  primary: '#051766',
  secondary: '#727272',
  third: '#374585',
  disabled: '#d3d3d3',
  sub_darkgray: '#3C3C3C',
  sub: '#57BBEB',
  fourth: '#28794E',
  stroke: '#DA291C',
  hover: {
    primary: '#57BBEB',
    secondary: '#505050',
    third: '#051766',
    default: '#eaeaea',
  },
  text: {
    basic: '#051766',
    basicTab: '#051766',
    sub: '#374585',
    guide: '#727272',
    category: '#9c52ff',
    price: '#051766',
    white: '#ffffff',
    placeholder: '#a3a3a3',
    disabled: '#bdbdbd',
    error: '#DA291C',
    event: '#7e9ae3',
    normal: '#051766',
    mileage: '#fbff94',
    attendance: '#051766',
    attendanceEvent: '#051766',
    selected: '#051766',
    food: '#fe6f1f',
    best: '#0dc335',
    policy: '#051766',
    newPlaceholder: '#595959',
  },
  point: {
    basic: '#051766',
    negative: '#DA291C',
  },
  line: {
    basic: '#eaeaea',
    background: '#dfdfdf',
    emphasis: '#051766',
    category: '#9c52ff',
    price: '#051766',
    disabled: '#d3d3d3',
    error: '#f22214',
    selected: '#051766',
    sub: '#bdbdbd',
    line02: '#d3d3d3',
  },
  background: {
    basic: '#DDF1FB',
    sub: '#DDF1FB',
    sub1: '#57BBEB',
    sub2: '#f3f3f3',
    white: '#ffffff',
    disabled: '#d3d3d3',
    gradient: '#FF8718',
    coupon: {
      good: '#efedff',
      cart: '#fff1ed',
      delivery: '#e2f8ff',
      default: '#5a5a5a',
    },
    arrow: {
      md: '#DDF1FB',
    },
    navigation: '#f7f7f7',
    error: '#ffa2a2',
  },
  icon: {
    default: '#919191',
    current: '#051766',
    normal: '#6a6a6a',
    badge: '#27b7db',
    benefit: '#e0dcff',
  },
};

export const font = {
  family: "'KoreanAir Sans', 'Noto Sans KR', sans-serif, Verdana, Arial !important",
  size: {
    tiny: '10px',
    calendar: '11px',
    error: '12px',
    small: '13px',
    basic: '14px',
    table: '15px',
    label: '16px',
    menu: '17px',
    title: '18px',
    popup: '20px',
    medium: '21px',
    percent: '22px',
    banner: '24px',
    discount: '26px',
    large: '28px',
    hero: '48px',
  },
  weight: {
    demiLight: 300,
    medium: 500,
    medium2: 400,
    bold: 600,
  },
  lineHeight: {
    demiLight: '160%',
    medium: '140%',
    bold: '100%',
  },
  'line-spacing': {},
};

export const image = {
  defaultChecked: defaultChecked,
  defaultDisabled: defaultDisabled,
  defaultUnchecked: defaultUnchecked,
  attendanceChecked: attendanceChecked,
};

export const mobile = {
  numberIndicator: {
    suffixColor: color.text.basic,
  },
  footer: {
    contactInfo: {
      borderRadius: '10px',
    },
  },
  myCouponSeeMoreButton: {
    border: '',
  },
};

export const component = {
  input: {
    // input border가 border bottom만 있을수 있으므로 통으로집어넣음
    defaultBorder: `border-bottom: 1px solid ${color.line.emphasis};`,
    disabledBorder: `border-bottom: 1px solid ${color.line.disabled};`,
    selectedBorder: `border-bottom: 1px solid ${color.line.emphasis};`,
    errorBorder: `border-bottom: 1px solid ${color.line.error};`,
  },
  button: {
    borderRadius: '50px',
    border: color.line.emphasis,
    primary: {
      backgroundColor: '#57BBEB',
      pressed: {
        color: '#ffffff',
      },
      hover: {
        backgroundColor: '#57BBEB',
      },
      color: '#051766',
    },
    secondary: {
      color: '#051766',
      border: '1px solid #051766',
      backgroundColor: '#ffffff',
      hover: {
        backgroundColor: '#eaeaea',
      },
      pressed: {
        backgroundColor: '#ffffff',
      },
    },
    third: {
      backgroundColor: '#57BBEB',
      pressed: {
        color: '#ffffff',
      },
      hover: {
        backgroundColor: '#57BBEB',
      },
      color: '#051766',
    },
    default: {
      border: '1px solid #051766',
    },
  },
  dropdown: {
    // dropdown border가 border bottom만 있을수 있으므로 통으로집어넣음
    defaultBorder: `border-bottom: 1px solid ${color.line.emphasis};`,
    fontSize: '14px',
  },
  numberIndicator: {
    border: '0',
    borderRadius: '0',
    background: '',
    width: 'auto',
    padding: '0',
    button: {
      border: `1px solid ${color.line.basic}`,
      borderRadius: '99px',
      background: `${color.background.white}`,
    },
  },
  imageFileUploader: {
    borderRadius: '10px',
  },
  swiperMainItem: {
    bannerText1: {
      top: '104px',
    },
    bannerText2: {
      top: '162px',
    },
    bannerText3: {
      top: '270px',
    },
  },
  gnb: {
    logo: {
      marginRight: '55px',
    },
    cart: {
      top: -1,
      right: -8,
    },
  },
  good: {
    selectedOption: {
      borderRadius: '10px',
    },
  },
  order: {
    orderContentHeader: {
      borderBottom: `2px solid ${color.line.emphasis}`,
      paddingBottom: '14px',
    },
    orderContainer: {
      borderRadius: '10px',
    },
    headerContainer: {
      borderTop: '',
      borderRadius: '10px 10px 0 0',
    },
    orderGoodItemInformation: {
      orderContainer: {
        borderTop: `1px solid ${color.line.background}`,
      },
    },
    orderGoodContent: {
      orderGoodList: {
        borderRadius: '0 0 10px 10px',
      },
    },
    payment: {
      agreeTermsConditions: {
        root: {
          borderRadius: '10px',
        },
      },
      orderPaymentTermsAccordion: {
        accordion: {
          borderRadius: '10px',
        },
        flexBox: {
          borderRadius: '10px 10px 0 0',
        },
      },
    },
    cart: {
      optionButton: {
        border: `1px solid ${color.primary}`,
        borderRadius: '10px',
      },
    },
  },
  myPage: {
    myPageOrderPage: {
      periodSearch: {
        borderRadius: '10px',
      },
    },
    myPageOrderList: {
      orderMasterContainer: {
        // 없을 수도 있기때문에 통으로 삽입
        borderTop: '',
        borderRadius: '10px',
      },
    },
    myPageOrderListItemHead: {
      container: {
        borderRadius: '10px 10px 0 0',
      },
    },
    deliveryLocation: {
      cellButton: {
        borderRadius: '34px',
      },
    },
  },
  customerService: {
    informationEntryGrid: {
      labelBox: {
        backgroundColor: color.background.white,
      },
    },
  },
  termViewForm: {
    textBox: {
      borderRadius: '10px',
    },
  },
  mobile,
};

export const theme = {
  id: 'skypass',
  favicon,
  color,
  font,
  image,
  component,
};

export default theme;
